// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  VersionStatus,
} from "./types";


export default __t.row({
  versionId: __t.u64().primaryKey().name("version_id"),
  assetId: __t.u64().name("asset_id"),
  version: __t.u32(),
  get status() {
    return VersionStatus;
  },
  releaseNotes: __t.string().name("release_notes"),
  totalSizeBytes: __t.u64().name("total_size_bytes"),
  fileCount: __t.u32().name("file_count"),
  createdAt: __t.timestamp().name("created_at"),
  publishedAt: __t.option(__t.timestamp()).name("published_at"),
  createdBy: __t.identity().name("created_by"),
  renditionId: __t.u64().name("rendition_id"),
});
